<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛-首页">
		<PHeader :checkId="'律所简介29'"  :activeNames="'关于我们'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">关于我们</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">About Us</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 / 关于我们</span>
				<span style="color:#333333;font-size:14px;"> / 律所简介</span>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;">律所简介</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;">Company Profile</div>
			<div style="margin-left: 3%;margin-top: 5px;width: 20px;height: 3px;background: #AA1100;"></div>
			<div style="margin-left: 3%;margin-top: 20px;width:94%;">
				<img style="width:100%;" src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/u5_div.png">
			</div>
			<div style="margin-top:20px;color:#8D8D8D;margin-left:3%;width:94%;">
				上海和华利盛律师事务所经上海市司法局核准于2001年在上海市黄浦区成立，先后在重庆、西安、唐山、郑州、海口、太原、合肥设有分所，同时在香港、悉尼等地设有办公室或战略合作伙伴。
			</div>
			<div style="margin-top:20px;color:#8D8D8D;margin-left:3%;width:94%;">
				中文名“和华利盛”：包含“和为贵”、“和谐中华”、“专注商业”、“繁荣昌盛”之义。英文名HAWORTH & LEXON：英语与拉丁文的组合，意为“法律之上的价值”。
			</div>
			<div style="margin-top:20px;color:#8D8D8D;margin-left:3%;width:94%;">
				和华利盛自成立以来，积极学习国际、国内领先律所的先进运营经验，践行“专业、精致”的海派律师理念，以助力客户成长、成功为目标，以团队合作为基石，以专业化服务为依托，多年来，赢得了包括多家世界500强企业在内的众多客户的认可，在律师业和社会各界享有良好的声誉。
			</div>
			<div style="margin-top:20px;color:#8D8D8D;margin-left:3%;width:94%;">
				和华利盛执业律师多数具有国内及国外著名大学硕士或博士学位，能在包括新能源、汽车、医疗、教育、网络安全、银行、保险、电力、通讯 、软件、高新技术、矿产等多个行业领域提供专业法律服务。
			</div>	
			<div style="margin-top:20px;color:#8D8D8D;margin-left:3%;width:94%;">
				和华利盛自成立以来，多次获得著名法律杂志The Asia Pacific Legal 500（亚太法律500强）重点推荐，被选任为“世博推荐法律服务供应商”，获评“上海市优秀律师事务所”，被ALB（亚洲法律杂志－中国版）评为“最值得关注的10家律师事务所”。
			</div>
			<div style="margin-top:40px;margin-left:3%;width:94%;height:80px;text-align: center;">
				<div style="float:left;width:calc(22% - 2px);margin-right:1%;">
					<div style="color: #8D8D8D;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">专业人员</div>
					<div style="font-size: 24px;margin-top: 5px;font-weight: 900;color: #AA1100;">100+</div>
				</div>
				<div style="float:left;width:1px;height:30px;margin-top:15px;background-color:#D89088"></div>
				<div style="float:left;width:calc(28% - 2px);margin-left:1%;margin-right:1%;">
					<div style="color: #8D8D8D;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">分所及办事处</div>
					<div style="font-size: 24px;margin-top: 5px;font-weight: 900;color: #AA1100;">7</div>
				</div>
				<div style="float:left;width:1px;height:30px;margin-top:15px;background-color:#D89088"></div>
				<div style="float:left;width:calc(22% - 2px);margin-left:1%;margin-right:1%;">
					<div style="color: #8D8D8D;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">服务客户</div>
					<div style="font-size: 24px;margin-top: 5px;font-weight: 900;color: #AA1100;">500+</div>
				</div>
				<div style="float:left;width:1px;height:30px;margin-top:15px;background-color:#D89088"></div>
				<div style="float:left;width:calc(22% - 2px);margin-left:1%;">
					<div style="color: #8D8D8D;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">战略伙伴</div>
					<div style="font-size: 24px;margin-top: 5px;font-weight: 900;color: #AA1100;">50+</div>
				</div>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;">合作伙伴</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;">Partners</div>
			<div style="margin-left: 3%;margin-top: 5px;width: 20px;height: 3px;background: #AA1100;"></div>

			
			<el-carousel class="parentCarousel" style="height:200px;width:97%;margin-left:3%;margin-top:0px;" :autoplay="true">
				<el-carousel-item v-for="(item,index) in parentList" :key="'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/'+(index+1)+'.png'" style="height:100%;width:100%;">
					<!-- <img v-for="item2 in item" :key="'img'+item2+index" :style="{'margin-top':'20px',float:'left','margin-right':item2%2 != 0?'2%':'0','margin-left':item2%2 == 0?'2%':'0',width: 'calc(30% - 2px)','line-height':'65px',height: '65px',border: '1px solid #EAEAEA'}" :src="'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/'+(item2)+'.png'"> -->
					<img v-for="item2 in item" :key="'img'+item2+index" :style="{'margin-top':'20px',float:'left','margin-right':'3%',width: 'calc(30% - 2px)','line-height':'65px',height: '65px',border: '1px solid #EAEAEA'}" :src="'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/'+(item2)+'.png'">

				</el-carousel-item>
			</el-carousel>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				parentList:[
					[1,2,3,4,5,6],
					[7,8,9,10,11,12],
					[13,14,15,16,17,18],
					[19,20,21,22,23,24],
					[25,26,27,28,29,30],
					[31,32,33,34,35,36]
				]
			}
		},
		mounted() {
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter /deep/ .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel /deep/ .el-carousel__container{
		height: 100%;
	}
	body /deep/ .v-modal{
		display: none;
	}
</style>
